import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from 'react-toolbox/lib/card';
import Checkbox from 'react-toolbox/lib/checkbox';
import Markdown from './Markdown';
import CardBody from './CardBody';
import LoadingButton from './LoadingButton';
import styles from './ConsentForm.scss';

const propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    btnSubmit: PropTypes.string,
    consentAgreement: PropTypes.string,
  }),
};

class ConsentForm extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isSubmitting: false,
      confirmed: false,
    };
  }

  handleChange(value, e) {
    this.setState({
      [e.target.name]: value,
    });
  }

  handleSubmit() {
    this.setState({
      isSubmitting: true,
    });
    this.props.onSubmit();
  }

  render() {
    const { className, content } = this.props;
    if (!content) return null;

    const { confirmed, isSubmitting } = this.state;

    const wrapperClasses = classNames(className);
    return (
      <Card className={wrapperClasses}>
        <CardBody className={styles.content}>
          <Markdown
            source={`# ${content.title}\n ${content.body}`}
            styled
            bodyStyle
          />
        </CardBody>
        <div className={styles.actions}>
          <Checkbox
            checked={confirmed}
            name="confirmed"
            onChange={this.handleChange}
            className={styles.checkbox}
            theme={styles}
          >
            <Markdown
              source={content.consentAgreement}
              className={styles.consentText}
            />
          </Checkbox>
          <LoadingButton
            raised
            accent
            onClick={this.handleSubmit}
            className={styles.btnSubmit}
            isLoading={isSubmitting}
            disabled={!confirmed || isSubmitting}
          >
            {content.btnSubmit}
          </LoadingButton>
        </div>
      </Card>
    );
  }
}

ConsentForm.propTypes = propTypes;

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/client/src/components/ConsentForm.js